import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import Alert from 'components/Shared/Alert';
import { IOption } from 'components/Shared/DropdownMenu';
import Snackbar from 'components/Shared/Snackbar';
import { IDocument } from 'interfaces/document';
import { IEntity } from 'interfaces/entity';
import DeleteIcon from 'mdi-react/DeleteIcon';
import EditIcon from 'mdi-react/EditIcon';
import VisibilityIcon from 'mdi-react/VisibilityIcon';
import VisibilityOffIcon from 'mdi-react/VisibilityOffIcon';
import * as React from 'react';
import rxjsOperators from 'rxjs-operators';
import documentService from 'services/document';

interface IState extends IStateListItem {
  deleted?: boolean;
  entityInfo: any;
}

interface IProps {
  document: IDocument;
  isSelected: boolean;
  onSelect: () => void;
  onEdit: (document: IDocument) => void;
  onShowHideComplete: () => void;
  onDeleteComplete: () => void;
  entities: IEntity[],
}

export default class ListItem extends ListItemComponent<IProps, IState> {
  private readonly options: IOption[];

  constructor(props: IProps) {
    super(props);
    this.options = [{
      text: props.document.hidden ? 'Exibir' : 'Ocultar',
      icon: props.document.hidden ? VisibilityIcon : VisibilityOffIcon,
      handler: this.handleShowHide
    }, {
      text: 'Editar',
      icon: EditIcon,
      handler: this.handleEdit
    }, {
      text: 'Excluir',
      icon: DeleteIcon,
      handler: this.handleDelete
    }];
    this.state = {
      ...this.state,
      deleted: false,
      entityInfo: {},
    };
  }

  componentDidMount = () => {
    const { entityId, tabId, subTabId } = this.props.document;
    const entity = this.props.entities.find(entity => entity.id === entityId);
    const tab = this.props.entities.find(entity => entity.id === tabId);
    const subTab = this.props.entities.find(entity => entity.id === subTabId);

    return this.setState({
      deleted: false,
      entityInfo: {
        entity: entity ? entity.name : '',
        tab: tab ? tab.name : '',
        subTab: subTab ? subTab.name : '-',
      }
    });
  }

  handleDelete = async () => {
    const { document, onDeleteComplete } = this.props;
    const title = `Tem certeza que deseja excluir o documento "${document.name}"?`;
    const ok = await Alert.confirm({ title, mode: 'delete' });
    if (!ok) return;

    this.setState({ loading: true });

    documentService.delete(document.id).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(() => {
      Snackbar.show(`${document.name} foi removido`);
      this.setState({ loading: false, deleted: true });
      onDeleteComplete();
    }, error => {
      this.setState({ loading: false, error });
    });
  }

  handleShowHide = async () => {
    const { document, onShowHideComplete } = this.props;
    const message = `Deseja ${document.hidden ? 'deixar visível' : 'ocultar'} o documento ${document.name}?`;
    const ok = await Alert.confirm({ title: '', message });
    if (!ok) return;

    this.setState({ loading: true });

    const documentFormatted = {
      ...document,
      hidden: !document.hidden
    };

    delete documentFormatted.venture;
    delete documentFormatted.entity;
    delete documentFormatted.tab;
    delete documentFormatted.subTab;

    documentService.save(documentFormatted).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(() => {
      Snackbar.show(`${document.name} está ${!document.hidden ? 'oculto.' : 'visível.'}`);
      this.setState({ loading: false, deleted: false });
      onShowHideComplete();
    }, error => {
      this.setState({ loading: false, error });
    });
  }

  handleEdit = () => {
    const { document, onEdit } = this.props;
    onEdit(document);
  }

  render(): JSX.Element {
    const { deleted, entityInfo } = this.state;
    const { document, isSelected, onSelect } = this.props;

    if (deleted || !entityInfo) {
      return null;
    }

    return (
      <TableRow color='primary' tabIndex={-1} role="checkbox">
        <TableCell padding="checkbox">
          <Checkbox
            onClick={onSelect}
            checked={isSelected}
            color='primary'
            inputProps={{ 'aria-labelledby': document.name }}
          />
        </TableCell>
        <TableCell>{document.name}</TableCell>
        <TableCell>{document.venture ? document.venture.name : '-'}</TableCell>
        <TableCell>{document.frequency}</TableCell>
        <TableCell>{document.criticality}</TableCell>
        <TableCell>{document.entity ? document.entity.name : '-'}</TableCell>
        <TableCell>{document.tab ? document.tab.name : '-'}</TableCell>
        <TableCell>{document.subTab ? document.subTab.name : '-'}</TableCell>
        <TableCell>
          {this.renderSideMenu(this.options)}
        </TableCell>
      </TableRow>
    );
  }
}